<template>
    <v-dialog v-model="dialogo" max-width="600px" persistent>
        <v-card>
            <v-list-item two-line>
                <v-list-item-title class="text-h5"> Relacionamentos </v-list-item-title>
                <v-spacer />
                <app-botao
                    :icone="true"
                    rotulo="fechar"
                    tipo="button"
                    estilo="fechar"
                    class=""
                    @acaoBotao="
                        dialogo = false;
                        sair();
                    "
                />
            </v-list-item>
            <v-divider class="mb-2" />
            <v-card-text>
                <v-list nav>
                    <v-list-item
                        v-for="(item, i) in relacionamentos"
                        :key="i"
                        link
                        shaped
                        @click="selecionar(item.Matricula, item.Relacionamento, item.Criptografado)"
                    >
                        <v-list-item-icon style="align-self: stretch">
                            <v-icon>{{ gerenciarRelacionamento(item).Icone }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title class="text-h6">
                            {{ gerenciarRelacionamento(item).Descricao }}
                        </v-list-item-title>

                        <v-list-item-icon class="d-flex align-center">
                            <v-btn color="green" text text-color="white" icon class="mr-2">
                                <v-icon>mdi-arrow-right</v-icon>
                            </v-btn>
                        </v-list-item-icon>
                    </v-list-item>
                </v-list>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import jwtDecode from "jwt-decode"
import Cookie from "@universidade-franciscana/componente-front/src/utils/cookies.js"

import _enumRelacionamento from "@/enums/relacionamentos.js"

import _pessoaRelacionamento from "@/services/pessoa-relacionamento.js"

import AppBotao from "@universidade-franciscana/componente-front/src/components/comuns/botao/AppBotao.vue"

export default {
  components: {
    AppBotao,
  },
  props: {
    value: Boolean,
    listaRelacionamentos: { type: Array, default: null },
  },
  data() {
    return { relacionamentos: [] }
  },

  computed: {
    dialogo: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },

  mounted() {
    this.relacionamentos = this.listaRelacionamentos

    //busca os relacionamentos só quando ele é clicado no trocar relacionamento,
    // e esse botão estará disponível somente quando tem mais de um relacioanmento
    if (this.relacionamentos.length === 0) {
      _pessoaRelacionamento
        .relacionamentos(jwtDecode(Cookie.get("token")).Id)
        .then(x => {
          this.relacionamentos = JSON.parse(x).filter(y => y.Fim === null)
        })
    }
  },

  methods: {
    retornaIdentificador(relacionamento) {
      return _enumRelacionamento.PROFESSOR.Id === relacionamento.Relacionamento
        ? this.idPessoa
        : relacionamento.Criptografado
    },

    gerenciarRelacionamento(relacionamento) {
      return _enumRelacionamento.ALUNO.Id === relacionamento.Relacionamento
        ? {
            Descricao: relacionamento.Cursos[0].NomeCurso,
            Icone: "mdi-account-school-outline",
          }
        : _enumRelacionamento.TECNICO_ADMINISTRATIVO.Id ===
          relacionamento.Relacionamento
        ? _enumRelacionamento.TECNICO_ADMINISTRATIVO
        : _enumRelacionamento.PROFESSOR.Id === relacionamento.Relacionamento
        ? _enumRelacionamento.PROFESSOR
        : null
    },

    sair() {
      window.location.href = "https://minha.ufn.edu.br"
    },

    selecionar(matricula, relacionamento, criptografado) {
      this.$emit("selecionar", matricula, relacionamento, criptografado, this.relacionamentos.length)
    },
  },
}
</script>